import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import { useEffect, useState } from "react";
import {
  getlocal,
  getStorage,
  setStorage,
} from "../../../functions/localstorage";
import {
  baseurl,
  DeleteRecord,
  ErrorAlert,
  getList,
  GetRecords,
  saveRecord,
  SuccessAlert,
  UpdateRecord,
  UploadFile,
  URLPRIFIX,
  WarningAlert,
} from "../../../functions/api";
import AccountsLayout from "../AccountsLayout";
import FormView from "../../../Components/Elements/FormView";
import { MdEdit, MdOutlineFileUpload } from "react-icons/md";
import { FaRegEye } from "react-icons/fa6";
import { HiOutlineArrowSmDown, HiOutlineArrowSmUp } from "react-icons/hi";
import { PrimaryBTN } from "../../../Constancs/cssconst";
import { FaArrowRight, FaEdit, FaPenNib, FaTruckLoading } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { IoIosCloseCircleOutline } from "react-icons/io";
import BulkActionsBar from "../../../Components/Elements/BulkActionsBar";
import ExportOptionsModal from "../../../Components/Elements/ExportOptionsModal";
import ListViewUp from "../../../Components/Elements/ListViewUp";


import {
  URL_Account_Charts_List,
  URL_Account_Client_Create,
  URL_Account_Client_Update,
  URL_Account_Customer_By_ID,
  URL_Account_Customer_Create,
  URL_Account_Customer_Update,
} from "../../../Constancs/apiconst";
import { emphasize } from "@mui/material";
import Select from "react-select";
import ListView from "../../../Components/Elements/ListView";

function FormHeader({
  State = "New",
  FormName = "",
  FormNumber = "",
  Actions = [],
}) {
  return (
    <div className="flex items-center justify-between bg-secondary h-[38px] rounded-lg p-1 shadow-[0px_0px_10px_3px_rgba(0,0,0,0.1)] ">
      <div className="flex gap-3 h-full items-center">
        <span className=" text-[14px] border flex items-center px-1 py-0.5 rounded-lg">
          {State}
        </span>
        <span className="text-[14px]  flex flex-col">
          <span className="text-[12px] font-bold text-Ocean_Blue">
            {FormName}
          </span>
          <span className="text-[14px] font-semibold ">{FormNumber}</span>
        </span>
      </div>
      <div className="flex gap-3 h-full items-center mr-8">
        {Actions.map((item, index) => {
          if (item.visible)
            return (
              <button
                key={index}
                className={
                  "border px-2 py-1 rounded-lg font-semibold hover:bg-tertiary " +
                  (item.type === "primary"
                    ? " bg-Ocean_Blue text-secondary "
                    : " bg-Alice_Blue ")
                }
                onClick={item.onClick}
              >
                {item.ButtonName}
              </button>
            );
        })}
      </div>
    </div>
  );
}

function FormStage({ Stages = [] }) {
  return (
    <div className="flex items-center justify-center h-[38px] gap-3">
      {Stages.map((stage, index) => (
        <div key={index} className=" flex gap-1 items-center">
          <span
            className={
              " border p-1 rounded-full text-[14px] " +
              (stage.selected
                ? " bg-Ocean_Blue text-secondary "
                : stage.completed
                  ? " bg-[#3ec95c] text-secondary "
                  : " ")
            }
          >
            {stage.completed ? <TiTick /> : stage.icon}
          </span>
          <h3 className="text-[14px] pr-3">{stage.Name}</h3>
          {index < Stages.length - 1 ? <FaArrowRight /> : ""}
        </div>
      ))}
    </div>
  );
}

function TabsView({ tabsList = [], className = "", tabs, settabs }) {
  return (
    <ul
      className={
        className +
        " flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
      }
    >
      <li className="me-2">
        {tabsList.map((tab, tabId) => (
          <button
            key={tabId}
            className={
              " p-2 text-primary  rounded-t-lg hover:bg-tertiary hover:text-primary " +
              (tabId === tabs
                ? " bg-Ocean_Blue text-secondary "
                : " bg-Alice_Blue ")
            }
            onClick={() => {
              tab.onClick && tab.onClick();
              settabs(tabId);
            }}
          >
            {tab.name}
          </button>
        ))}
      </li>
    </ul>
  );
}

const CustomerForm = () => {
  const { companyId, option, customerId } = useParams();
  const navigate = useNavigate();
  const getrecord = `/users/users/${customerId}`;
  const attachment_url_Prefix = "customers_";
  const store = useStore();
  let storage = getStorage();
  const [tabs, settabs] = useState(0);
  var states = {
    India: [
      { value: "Andhra Pradesh", label: "Andhra Pradesh" },
      { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
      { value: "Assam", label: "Assam" },
      { value: "Bihar", label: "Bihar" },
      { value: "Chhattisgarh", label: "Chhattisgarh" },
      { value: "Goa", label: "Goa" },
      { value: "Gujarat", label: "Gujarat" },
      { value: "Haryana", label: "Haryana" },
      { value: "Himachal Pradesh", label: "Himachal Pradesh" },
      { value: "Jharkhand", label: "Jharkhand" },
      { value: "Karnataka", label: "Karnataka" },
      { value: "Kerala", label: "Kerala" },
      { value: "Madhya Pradesh", label: "Madhya Pradesh" },
      { value: "Maharashtra", label: "Maharashtra" },
      { value: "Manipur", label: "Manipur" },
      { value: "Meghalaya", label: "Meghalaya" },
      { value: "Mizoram", label: "Mizoram" },
      { value: "Nagaland", label: "Nagaland" },
      { value: "Odisha", label: "Odisha" },
      { value: "Punjab", label: "Punjab" },
      { value: "Rajasthan", label: "Rajasthan" },
      { value: "Sikkim", label: "Sikkim" },
      { value: "Tamil Nadu", label: "Tamil Nadu" },
      { value: "Telangana", label: "Telangana" },
      { value: "Tripura", label: "Tripura" },
      { value: "Uttar Pradesh", label: "Uttar Pradesh" },
      { value: "Uttarakhand", label: "Uttarakhand" },
      { value: "West Bengal", label: "West Bengal" },
    ],
    Malaysia: [
      { value: "Johor", label: "Johor" },
      { value: "Kedah", label: "Kedah" },
      { value: "Kelantan", label: "Kelantan" },
      { value: "Melaka", label: "Melaka" },
      { value: "Negeri Sembilan", label: "Negeri Sembilan" },
      { value: "Pahang", label: "Pahang" },
      { value: "Penang", label: "Penang" },
      { value: "Perak", label: "Perak" },
      { value: "Perlis", label: "Perlis" },
      { value: "Sabah", label: "Sabah" },
      { value: "Sarawak", label: "Sarawak" },
      { value: "Selangor", label: "Selangor" },
      { value: "Terengganu", label: "Terengganu" },
      { value: "Kuala Lumpur", label: "Kuala Lumpur (Federal Territory)" },
      { value: "Putrajaya", label: "Putrajaya (Federal Territory)" },
      { value: "Labuan", label: "Labuan (Federal Territory)" },
    ],
    "Sri Lanka": [
      { value: "Central", label: "Central Province" },
      { value: "Eastern", label: "Eastern Province" },
      { value: "Northern", label: "Northern Province" },
      { value: "North Central", label: "North Central Province" },
      { value: "North Western", label: "North Western Province" },
      { value: "Sabaragamuwa", label: "Sabaragamuwa Province" },
      { value: "Southern", label: "Southern Province" },
      { value: "Uva", label: "Uva Province" },
      { value: "Western", label: "Western Province" },
    ],
    "United Arab Emirates": [
      { value: "Abu Dhabi", label: "Abu Dhabi" },
      { value: "Dubai", label: "Dubai" },
      { value: "Sharjah", label: "Sharjah" },
      { value: "Ajman", label: "Ajman" },
      { value: "Fujairah", label: "Fujairah" },
      { value: "Ras Al Khaimah", label: "Ras Al Khaimah" },
      { value: "Umm Al Quwain", label: "Umm Al Quwain" },
    ],
    "United States of America": [
      { value: "Alabama", label: "Alabama" },
      { value: "Alaska", label: "Alaska" },
      { value: "Arizona", label: "Arizona" },
      { value: "Arkansas", label: "Arkansas" },
      { value: "California", label: "California" },
      { value: "Colorado", label: "Colorado" },
      { value: "Connecticut", label: "Connecticut" },
      { value: "Delaware", label: "Delaware" },
      { value: "Florida", label: "Florida" },
      { value: "Georgia", label: "Georgia" },
      { value: "Hawaii", label: "Hawaii" },
      { value: "Idaho", label: "Idaho" },
      { value: "Illinois", label: "Illinois" },
      { value: "Indiana", label: "Indiana" },
      { value: "Iowa", label: "Iowa" },
      { value: "Kansas", label: "Kansas" },
      { value: "Kentucky", label: "Kentucky" },
      { value: "Louisiana", label: "Louisiana" },
      { value: "Maine", label: "Maine" },
      { value: "Maryland", label: "Maryland" },
      { value: "Massachusetts", label: "Massachusetts" },
      { value: "Michigan", label: "Michigan" },
      { value: "Minnesota", label: "Minnesota" },
      { value: "Mississippi", label: "Mississippi" },
      { value: "Missouri", label: "Missouri" },
      { value: "Montana", label: "Montana" },
      { value: "Nebraska", label: "Nebraska" },
      { value: "Nevada", label: "Nevada" },
      { value: "New Hampshire", label: "New Hampshire" },
      { value: "New Jersey", label: "New Jersey" },
      { value: "New Mexico", label: "New Mexico" },
      { value: "New York", label: "New York" },
      { value: "North Carolina", label: "North Carolina" },
      { value: "North Dakota", label: "North Dakota" },
      { value: "Ohio", label: "Ohio" },
      { value: "Oklahoma", label: "Oklahoma" },
      { value: "Oregon", label: "Oregon" },
      { value: "Pennsylvania", label: "Pennsylvania" },
      { value: "Rhode Island", label: "Rhode Island" },
      { value: "South Carolina", label: "South Carolina" },
      { value: "South Dakota", label: "South Dakota" },
      { value: "Tennessee", label: "Tennessee" },
      { value: "Texas", label: "Texas" },
      { value: "Utah", label: "Utah" },
      { value: "Vermont", label: "Vermont" },
      { value: "Virginia", label: "Virginia" },
      { value: "Washington", label: "Washington" },
      { value: "West Virginia", label: "West Virginia" },
      { value: "Wisconsin", label: "Wisconsin" },
      { value: "Wyoming", label: "Wyoming" },
    ],
    Germany: [
      { value: "Baden-Württemberg", label: "Baden-Württemberg" },
      { value: "Bavaria", label: "Bavaria" },
      { value: "Berlin", label: "Berlin" },
      { value: "Brandenburg", label: "Brandenburg" },
      { value: "Bremen", label: "Bremen" },
      { value: "Hamburg", label: "Hamburg" },
      { value: "Hesse", label: "Hesse" },
      { value: "Lower Saxony", label: "Lower Saxony" },
      { value: "Mecklenburg-Vorpommern", label: "Mecklenburg-Vorpommern" },
      { value: "North Rhine-Westphalia", label: "North Rhine-Westphalia" },
      { value: "Rhineland-Palatinate", label: "Rhineland-Palatinate" },
      { value: "Saarland", label: "Saarland" },
      { value: "Saxony", label: "Saxony" },
      { value: "Saxony-Anhalt", label: "Saxony-Anhalt" },
      { value: "Schleswig-Holstein", label: "Schleswig-Holstein" },
      { value: "Thuringia", label: "Thuringia" },
    ],
    France: [
      { value: "Auvergne-Rhône-Alpes", label: "Auvergne-Rhône-Alpes" },
      { value: "Bourgogne-Franche-Comté", label: "Bourgogne-Franche-Comté" },
      { value: "Brittany", label: "Brittany" },
      { value: "Centre-Val de Loire", label: "Centre-Val de Loire" },
      { value: "Corsica", label: "Corsica" },
      { value: "Grand Est", label: "Grand Est" },
      { value: "Hauts-de-France", label: "Hauts-de-France" },
      { value: "Île-de-France", label: "Île-de-France" },
      { value: "Normandy", label: "Normandy" },
      { value: "Nouvelle-Aquitaine", label: "Nouvelle-Aquitaine" },
      { value: "Occitanie", label: "Occitanie" },
      { value: "Pays de la Loire", label: "Pays de la Loire" },
      {
        value: "Provence-Alpes-Côte d'Azur",
        label: "Provence-Alpes-Côte d'Azur",
      },
    ],
    Italy: [
      { value: "Abruzzo", label: "Abruzzo" },
      { value: "Aosta Valley", label: "Aosta Valley" },
      { value: "Apulia", label: "Apulia" },
      { value: "Basilicata", label: "Basilicata" },
      { value: "Calabria", label: "Calabria" },
      { value: "Campania", label: "Campania" },
      { value: "Emilia-Romagna", label: "Emilia-Romagna" },
      { value: "Friuli Venezia Giulia", label: "Friuli Venezia Giulia" },
      { value: "Lazio", label: "Lazio" },
      { value: "Liguria", label: "Liguria" },
      { value: "Lombardy", label: "Lombardy" },
      { value: "Marche", label: "Marche" },
      { value: "Molise", label: "Molise" },
      { value: "Piedmont", label: "Piedmont" },
      { value: "Sardinia", label: "Sardinia" },
      { value: "Sicily", label: "Sicily" },
      { value: "Trentino-Alto Adige", label: "Trentino-Alto Adige" },
      { value: "Tuscany", label: "Tuscany" },
      { value: "Umbria", label: "Umbria" },
      { value: "Veneto", label: "Veneto" },
    ],
    England: [
      { value: "East Midlands", label: "East Midlands" },
      { value: "East of England", label: "East of England" },
      { value: "London", label: "London" },
      { value: "North East", label: "North East" },
      { value: "North West", label: "North West" },
      { value: "South East", label: "South East" },
      { value: "South West", label: "South West" },
      { value: "West Midlands", label: "West Midlands" },
      { value: "Yorkshire and the Humber", label: "Yorkshire and the Humber" },
    ],
    Scotland: [
      { value: "Aberdeen City", label: "Aberdeen City" },
      { value: "Edinburgh", label: "Edinburgh" },
      { value: "Glasgow", label: "Glasgow" },
      { value: "Highland", label: "Highland" },
      // ... You can expand this with all 32 council areas if needed
    ],
    Wales: [
      { value: "Cardiff", label: "Cardiff" },
      { value: "Swansea", label: "Swansea" },
      { value: "Newport", label: "Newport" },
      // ... Other unitary authorities
    ],
    "Northern Ireland": [
      { value: "Belfast", label: "Belfast" },
      { value: "Derry and Strabane", label: "Derry and Strabane" },
      { value: "Lisburn and Castlereagh", label: "Lisburn and Castlereagh" },
      // ... Additional districts
    ],
  };
  // *initial values
  const init = {
    clientname: "",
    person: "",
    phoneno: "",
    email: "",
    pan_no: "",
    gst_no: "",
    tax_acc_no: "",
    salaes_ledger_id: 0,
    receivable_ledger_id: 0,
    payable_ledger_id: 0,
    attachment_url: [],
    secondary_emails: [
      {
        name: "Email Id 1",
        email_Id: "",
      },
    ],
    // account_no: "",
    // account_holder_name: "",
    // bank_name: "",
    // branch: "",
    // ifsc_code: "",
    // bank_address: "",
    address: [
      {
        name: "Permanent Address",
        line_1: "",
        line_2: "",
        state: "",
        country: "",
        pincode: "",
      },
    ],
    company_id: [],
  };
  const initProps = {
    add: false,
    delete: false,
    on_off: false,
    print: false,
    update: false,
    view: false,
    attachment_url: {},
    clientname: {},
    person: {},
    phoneno: {},
    email: {},
    pan_no: {},
    gst_no: {},
    tax_acc_no: {},
    salaes_ledger_id: {
      salaes_ledger_id_list: [{ label: "Please Choose", value: "" }],
    },
    receivable_ledger_id: {
      receivable_ledger_id_list: [{ label: "Please Choose", value: "" }],
    },
    payable_ledger_id: {
      payable_ledger_id_list: [{ label: "Please Choose", value: "" }],
    },
    // account_no: {},
    // account_holder_name: {},
    // bank_name: {},
    company_id: {
      company_id_list: [{ label: "Please Choose", value: "" }],
    },
    // branch: {},
    // ifsc_code: {},
    // bank_address: {},
    address: {
      state_list: [{ value: "", label: "Please choose" }],
      countries_list: [
        { value: "", label: "Please choose" },
        { value: "India", label: "India" },

        { value: "Malaysia", label: "Malaysia" },
        { value: "Sri Lanka", label: "Sri Lanka" },
        { value: "United Arab Emirates", label: "United Arab Emirates" },
        {
          value: "United States of America",
          label: "United States of America",
        },
        { value: "Germany", label: "Germany" },
        { value: "France", label: "France" },
        { value: "Italy", label: "Italy" },
        { value: "England", label: "England" },
        { value: "Scotland", label: "Scotland" },
        { value: "Wales", label: "Wales" },
        { value: "Northern Ireland", label: "Northern Ireland" },
      ],
      addressmandatory: [],
    },
    secondary_emails: {
      secondary_emailsmandatory: [],
      hidden: true,
    },
  };

  // *states declaration for records and props
  const [Record, setRecord] = useState(init);
  const [props, setprops] = useState(initProps);

  // *initial values set on the page load
  // *and change on dependencies of option and id changes
  useEffect(() => {
    settabs(0);
    const localprops = getlocal("properties")?.customers || {};
    store.setmodule("customer", init);
    store.stopLoading();
    // store.startLoading();

    HandleMultiPropsChange(localprops);
    GetCompanyList();
    getPayableList();
    getReceivableList();
    getSalesList();
    HandleMultiPropsChange({
      clientname: { mandatory: true },
      company_id: { mandatory: true },
      email: { mandatory: false },
      phoneno: { mandatory: false},
      address: { hidden: false },
      // bank_name: { hidden: true },
      // account_holder_name: { hidden: true },
      // account_no: { hidden: true },
      // ifsc_code: { hidden: true },
      // branch: { hidden: true },
      // bank_address: { hidden: true },
      receivable_ledger_id: { hidden: true, mandatory: false },
      payable_ledger_id: { hidden: true, mandatory: false },
      salaes_ledger_id: { hidden: true },
      secondary_emails: { hidden: true },
    });
    if (option === "view") {
      HandleMultiPropsChange({
        clientname: { readonly: true },
        person: { readonly: true },
        phoneno: { readonly: true },
        email: { readonly: true },
        salaes_ledger_id: { readonly: true },
        receivable_ledger_id: { readonly: true },
        payable_ledger_id: { readonly: true },
        attachment_url: { readonly: true },
        secondary_emails: { readonly: true },
        address: { readonly: true },
        pan_no: { readonly: true },
        gst_no: { readonly: true },
        tax_acc_no: { readonly: true },
      });
    } else {
      HandleMultiPropsChange({
        clientname: { readonly: false, mandatory: true },
        person: { readonly: false },
        phoneno: { readonly: false, mandatory: false },
        email: { readonly: false, mandatory: false },
        salaes_ledger_id: { readonly: false },
        receivable_ledger_id: { readonly: false },
        payable_ledger_id: { readonly: false },
        attachment_url: { readonly: false },
        secondary_emails: { readonly: false, hidden: true },
        address: { readonly: false },
        pan_no: { readonly: false },
        gst_no: { readonly: false },
        tax_acc_no: { readonly: false },
      });
    }
    if (customerId != undefined) {
      LoadInitData();
    } else {
    }
  }, [option, customerId]);

  function LoadInitData() {
    GetRecords(URL_Account_Customer_By_ID + customerId + "/" + companyId).then(
      (res) => {
        if (res.success) {
          res = res.record;
          console.log("URL_Account_Customer_By_ID", res);
          let child = {};
          if (option === "view") {
            if (res?.projects?.length > 0) {
              var project = res?.projects || [];
              project = project.map((item) => {
                if (item.type == 11) {
                  item.type = "Non-Litigation";
                } else if (item.type == 12) {
                  item.type = "Litigation";
                } else if (item.type == 13) {
                  item.type = "TradeMark";
                }
                return { ...item };
              });
              child.Projects = {
                list: project,
                header: [
                  ["Project Name", "projectName"],
                  ["Type", "type"],
                  ["Priority", "priority"],
                  ["Status", "status"],
                  ["ActiveStatus", "activeStatus"],
                  ["Action", "ACTION"],
                ],
              };
            }
            if (res?.contacts?.length > 0) {
              child.Contacts = {
                list: res?.contacts,
                header: [
                  ["Customer", "clientName"],
                  ["E-Mail", "email"],
                  ["Phone Number", "phoneno"],
                  ["Film", "film_name"],
                  ["Action", "ACTION"],
                ],
              };
            }
            if (res?.invoices?.length > 0) {
              child.invoices = {
                list: res?.invoices,
                header: [
                  ["Invoice No", "invoice_no"],
                  ["Amount", "invoice_total"],
                  ["Due Amount", "invoice_due_amount"],
                  ["Due Date", "invoice_due_date"],
                  ["Status", "invoice_status"],
                  ["Action", "ACTION"],
                ],
              };
            }
            if (res?.expences?.length > 0) {
              child.expences = {
                list: res?.expences,
                header: [
                  ["Expense Number", "expense_no"],
                  // ["Delivery Address", "delivery_address"],
                  ["Expense Date", "expense_date"],
                  ["Notes", "expense_customer_notes"],
                  ["Amount", "expense_total"],
                  ["Status", "expense_status"],
                  ["Action", "ACTION"],
                ],
              };
            }
            if (res?.receipts?.length > 0) {
              child.receipts = {
                list: res?.receipts,
                header: [
                  ["Receipt Number", "receipt_no"],
                  ["Amount Received", "amount"],
                  // ["Customer Name", "customer_name"],
                  ["Receipt Date", "recepit_date"],
                  ["Action", "ACTION"],
                ],
              };
            }
            if (res?.journals?.length > 0) {
              child.journals = {
                list: res?.journals,
                header: [
                  ["DATE", "createdDate"],
                  ["JOURNAL ENTRY", "journal_no"],
                  ["Credit Account", "credit_Account"],
                  ["Debit Account ", "debit_Account"],
                  ["Amount ", "journal_total"],
                  ["STATUS", "journalstatus"],
                  ["ACTION", "ACTION"],
                ],
              };
            }
          }
          handleMultiFieldChange({
            clientname: res.clientname,
            company_id: res.company_id.map((item) => item.company_id),
            person: res.person,
            phoneno: res.phoneno,
            email: res.email,
            salaes_ledger_id: res.sales_ledger_id,
            receivable_ledger_id: res.receivable_ledger_id,
            payable_ledger_id: res.payable_ledger_id,
            pan_no: res.pan_no,
            gst_no: res.gst_no,
            tax_acc_no: res.tax_acc_no,
            attachment_url: res.attachment_url,
            // account_no: res.account_no,
            // account_holder_name: res.account_holder_name,
            // bank_name: res.bank_name,
            // branch: res.branch,
            // ifsc_code: res.ifsc_code,
            // bank_address: res.bank_address,
            address: JSON.parse(res?.address || "[]"),
            secondary_emails: JSON.parse(res?.secondary_emails || "[]"),
            child: child,
          });
          setSelectedOptions(
            res.company_id.map((item) => ({
              ...item,
              value: item.company_id,
              label: item.company_name,
            }))
          );

          let addressprops = JSON.parse(res?.address || "[]");
          let addresscheckmandatory = [...addressprops];
          addresscheckmandatory = addresscheckmandatory.map((item) => false);

          addressprops = addressprops.map((item) => {
            console.log("addressprops", item);
            return { value: item.state, label: item.state };
          });

          HandlePropsChange("address", {
            ...props.address,
            state_list: [...initProps.address.state_list, ...addressprops],
            addressmandatory: addresscheckmandatory,
          });
        }
      }
    );
  }

  //Load List of datas for dropdowns
  function getReceivableList() {
    getList({
      listUrl: URL_Account_Charts_List + companyId,
      field: "group_id",
      search: "10",
      count: 1000,
    }).then((res) => {
      if (res.success) {
        res = res?.data?.list || [];
        res = res.map((item) => ({
          value: item.id,
          label: item.ledger_name,
        }));
        console.log("URL_Account_Charts_List receivable", res);
        HandlePropsChange("receivable_ledger_id", {
          ...props.receivable_ledger_id,
          receivable_ledger_id_list: [
            ...initProps.receivable_ledger_id.receivable_ledger_id_list,
            ...res,
          ],
        });
      }
    });
  }
  function getPayableList() {
    getList({
      listUrl: URL_Account_Charts_List + companyId,
      field: "group_id",
      search: "11",
      count: 1000,
    }).then((res) => {
      if (res.success) {
        res = res?.data?.list || [];
        res = res.map((item) => ({
          value: item.id,
          label: item.ledger_name,
        }));
        console.log("URL_Account_Charts_List Payable", res);
        HandlePropsChange("payable_ledger_id", {
          ...props.payable_ledger_id,
          payable_ledger_id_list: [
            ...initProps.payable_ledger_id.payable_ledger_id_list,
            ...res,
          ],
        });
      }
    });
  }
  function getSalesList() {
    getList({
      listUrl: URL_Account_Charts_List + companyId,
      field: "group_id",
      search: "18",
      count: 1000,
    }).then((res) => {
      if (res.success) {
        res = res?.data?.list || [];
        res = res.map((item) => ({
          value: item.id,
          label: item.ledger_name,
        }));
        console.log("URL_Account_Charts_List Sales", res);
        HandlePropsChange("salaes_ledger_id", {
          ...props.salaes_ledger_id,
          salaes_ledger_id_list: [
            ...initProps.salaes_ledger_id.salaes_ledger_id_list,
            ...res,
          ],
        });
      }
    });
  }
  function GetCompanyList() {
    getList({
      listUrl: "/api/v2/accountingcompany/getcompany/",
    }).then((res) => {
      if (res.success) {
        // console.log("1234",res?.data?.list);
        res = res?.data?.list || [];
        res = res.map((item) => ({
          value: item.id,
          label: item.company_name,
        }));
        HandlePropsChange("company_id", {
          company_id_list: [...initProps.company_id.company_id_list, ...res],
        });
      }
    });
  }
  // *print the Record and Props if any value change between the Record and Props
  useEffect(() => {
    console.log("Record State change -> ", Record);
    console.log("Props State change -> ", props);
  }, [Record, props]);
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  // *create Or update the Record
  function update() {
    store.startLoading();
    let savedata = { ...Record };
    const email = savedata.email;
    if (savedata.email && !validateEmail(email)) {
      store.stopLoading();
      ErrorAlert("Invalid email address. Please enter a valid email.");
      return;
    }
    savedata.modified_by = store.getuser().id;
    savedata.address = JSON.stringify(savedata.address);
    savedata.secondary_emails = JSON.stringify(savedata.secondary_emails);
    if (
      CheckForAddress() &&
      CheckMandatory() &&
      CheckforCompany() 
      // &&
      // CheckForNumber()
    ) {
      UpdateRecord(
        URL_Account_Customer_Update + customerId + "/" + companyId,
        savedata
      ).then((res) => {
        console.log("Resonce of saveRecord - ", res);
        if (res.success) {
          store.stopLoading();
          SuccessAlert("Customer Submitted Successfully");
          navigate(
            `/${URLPRIFIX}/${companyId}/accounts/customer/view/${customerId}`,
            { replace: true }
          );
        } else {
          console.log("res error alert", res);
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.data?.message ||
            " Error Found Please contact the Admin"
          );
        }
      });
    }
  }
  function Submit() {
    store.startLoading();
    let savedata = { ...Record };
    const email = savedata.email;
    if (savedata.email && !validateEmail(email)) {
      store.stopLoading();
      ErrorAlert("Invalid email address. Please enter a valid email.");
      return;
    }
    savedata.modified_by = store.getuser().id;
    savedata.created_by = store.getuser().id;
    savedata.address = JSON.stringify(savedata.address);
    savedata.secondary_emails = JSON.stringify(savedata.secondary_emails);
    console.log("Submiting savedata", savedata);

    if (
      CheckForAddress() &&
      CheckMandatory() &&
      CheckforCompany()
      //  &&
      // CheckForNumber()
    ) {
      saveRecord(URL_Account_Customer_Create + "/" + companyId, savedata).then(
        (res) => {
          console.log("Resonce of saveRecord - ", res);
          if (res.success) {
            store.stopLoading();
            SuccessAlert("Customer Submitted Successfully");
            store.navback();
          } else {
            store.stopLoading();
            ErrorAlert(
              res?.errormessage?.data?.message ||
              " Error Found Please contact the Admin"
            );
          }
        }
      );
    }
  }
  // *Check for the mandatory fields if empty or not
  function CheckMandatory() {
    let out = true;
    for (let obj in props) {
      if (typeof props[obj] === "object") {
        if (props[obj].mandatory) {
          if (Record[obj] == "" || Record[obj] == " ") {
            HandlePropsChange(obj, { mandatory: true, show: true });
            out = false;
          } else {
            HandlePropsChange(obj, { mandatory: true, show: false });
          }
        }
      }
    }
    out === false && ErrorAlert("Please fill the Mandatory Fields.");
    out === false && store.stopLoading();
    return out;
  }
  function HandleAttachement(event) {
    var bodyFormData = new FormData();
    bodyFormData.append("file", event.target.files[0]);
    let attachment_url = Record.attachment_url || [];
    UploadFile(attachment_url_Prefix, bodyFormData).then((res) => {
      if (res.success) {
        handleFieldChange("attachment_url", [...attachment_url, res.data]);
      }
    });
  }

  function CheckForAddress() {
    let addressprops = [...props.address.addressmandatory];
    let out = true;
    Record.address.map((address, addressId) => {
      if (
        address?.line_1 != undefined &&
        address?.line_1 != "" &&
        address?.state != undefined &&
        address?.state != "" &&
        address?.country != undefined &&
        address?.country != "" &&
        address?.pincode != undefined &&
        address?.pincode != ""
      ) {
        console.log("address Found");
        addressprops[addressId] = false;
      } else {
        console.log("address not found");
        addressprops[addressId] = true;
        out = false;
      }
    });
    HandlePropsChange("address", {
      ...props.address,
      addressmandatory: [...addressprops],
    });
    out === false && ErrorAlert("Please fill the Mandatory Address Fields.");
    out === false && store.stopLoading();
    return out;
  }

  function CheckforCompany() {
    console.log("CheckforCompany", Record.company_id.length > 0);

    if (Record.company_id.length > 0) {
      HandlePropsChange("company_id", { ...props.company_id, show: false });
      return true;
    } else {
      HandlePropsChange("company_id", { ...props.company_id, show: true });
      WarningAlert("Please fill the Mandatory Fields.");
      store.stopLoading();
      return false;
    }
  }

  // function CheckForNumber() {
  //   let out = true;
  //   if (Record?.phoneno?.length < 8) {
  //     out = false;
  //     store.stopLoading();
  //     WarningAlert("Phone number need to have atlease 8 characters.");
  //     HandlePropsChange("phoneno", { mandatory: false, show: true });
  //   } else {
  //     HandlePropsChange("phoneno", { mandatory: false, show: false });
  //   }
  //   if (Record?.gst_no == "") {
  //     return out;
  //   } else if (Record?.gst_no?.length > 15) {
  //     out = false;
  //     store.stopLoading();
  //     WarningAlert("GSt number need to have atlease 15 characters.");
  //     HandlePropsChange("gst_no", { show: true });
  //   } else {
  //     HandlePropsChange("gst_no", { show: false });
  //   }
  //   return out;
  // }

  // *Handle Fields changes in Record States
  function handleFieldChange(fieldName, value) {
    setRecord((prev) => {
      return { ...prev, [fieldName]: value };
    });
  }
  function handleMultiFieldChange(value = {}) {
    setRecord((prev) => {
      for (let fieldName in value) {
        prev[fieldName] = value[fieldName];
      }
      return { ...prev };
    });
  }
  // *Handle Props Changes in Props States
  function HandlePropsChange(fieldName, value = {}) {
    setprops((prev) => {
      let oldprop = prev[fieldName];

      for (let prophead in value) {
        oldprop[prophead] = value[prophead];
      }
      prev[fieldName] = oldprop;
      return { ...prev };
    });
  }
  function HandleMultiPropsChange(NewProps = {}) {
    setprops((prev) => {
      for (let fieldName in NewProps) {
        let oldprop = prev[fieldName];
        let newprop = NewProps[fieldName];
        console.log("typeof newprop", typeof newprop);

        if (typeof newprop === "object") {
          for (let prophead in newprop) {
            oldprop[prophead] = newprop[prophead];
          }
          prev[fieldName] = oldprop;
        } else {
          prev[fieldName] = newprop;
        }
      }
      console.log("updated props", prev);

      return { ...prev };
    });
  }

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    const selectedindexs = selected.map((option) => option.value);
    setRecord((prev) => ({
      ...prev,
      company_id: selectedindexs,
    }));
  };

  return (
    <div className="flex flex-col h-full text-[12px]">
      <FormHeader
        // State="Draft"
        FormName="Customer"
        FormNumber={
          Record.clientname === "" ? "New Customer" : Record.clientname
        }
        Actions={[
          {
            ButtonName: "Submit",
            type: "primary",
            onClick: Submit,
            visible: customerId === undefined,
          },
          {
            ButtonName: "Update",
            type: "primary",
            onClick: update,
            visible:
              option === "edit" && customerId !== undefined && props.update,
          },
          {
            ButtonName: "Edit",
            onClick: () => {
              navigate(
                `/${URLPRIFIX}/${companyId}/accounts/customer/edit/${customerId}`,
                { replace: true }
              );
            },
            visible:
              option === "view" && customerId !== undefined && props.update,
          },
          {
            ButtonName: "Back",
            onClick: () => {
              navigate(-1);
            },
            visible: true,
          },
        ]}
      />
      {/* <FormStage Stages={props.Stages.Stages_list} /> */}
      <div className="flex bg-secondary flex-col items-center flex-grow rounded-lg shadow-[0px_0px_10px_3px_rgba(0,0,0,0.1)] overflow-auto">
        <div className="grid grid-cols-2 gap-2 w-[80%] mt-5">
          <div // clientname
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.clientname.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Customer Name
              {props.clientname.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.clientname.mandatory && props.clientname.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"clientname"}
              type="text"
              value={Record.clientname}
              disabled={props.clientname.readonly}
              onChange={(event) => {
                handleFieldChange("clientname", event.target.value);
              }}
            />
          </div>
          <div // email
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.email.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              E-Mail Id
              {/* {props.email.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )} */}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none "
                //  +
                // (props.email.mandatory && props.email.show
                //   ? " rounded-2xl border-2 border-[#ff2828] "
                //   : "")
              }
              id={"email"}
              type="text"
              value={Record.email}
              disabled={props.email.readonly}
              onChange={(event) => {
                handleFieldChange("email", event.target.value);
              }}
            />
          </div>
          <div // person
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.person.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Contact Person
              {props.person.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.person.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"person"}
              type="text"
              value={Record.person}
              disabled={props.person.readonly}
              onChange={(event) => {
                handleFieldChange("person", event.target.value);
              }}
            />
          </div>
          <div // phoneno
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.phoneno.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Phone Number
              {/* {props.phoneno.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )} */}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " 
                // +
                // (props.phoneno.mandatory && props.phoneno.show
                //   ? " rounded-2xl border-2 border-[#ff2828] "
                //   : "")
              }
              id={"phoneno"}
              type="number"
              value={Record.phoneno}
              disabled={props.phoneno.readonly}
              onChange={(event) => {
                handleFieldChange("phoneno", event.target.value);
              }}
            />
          </div>
          <div //company_id
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.company_id.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Company
              {props.company_id.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <Select
              className={
                "w-full" +
                (props.company_id.mandatory && props.company_id.show
                  ? " rounded-1xl border-2 border-[#ff2828] "
                  : "")
              }
              isMulti
              name="Company"
              options={props.company_id.company_id_list}
              value={selectedOptions}
              onChange={handleChange}
            />
          </div>
          <div // gst_no
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.gst_no.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              GST Number
              {props.gst_no.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.gst_no.mandatory && props.gst_no.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"gst_no"}
              type="text"
              value={Record.gst_no}
              disabled={props.gst_no.readonly}
              onChange={(event) => {
                handleFieldChange("gst_no", event.target.value);
              }}
            />
          </div>
          <div // pan no
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.pan_no.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              PAN Number
              {props.pan_no.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.pan_no.mandatory && props.pan_no.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"pan_no"}
              type="text"
              value={Record.pan_no}
              disabled={props.pan_no.readonly}
              onChange={(event) => {
                handleFieldChange("pan_no", event.target.value);
              }}
            />
          </div>

          <div // tax_acc_no
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.tax_acc_no.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              TAN Number
              {props.tax_acc_no.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.tax_acc_no.mandatory && props.tax_acc_no.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"tax_acc_no"}
              type="text"
              value={Record.tax_acc_no}
              disabled={props.tax_acc_no.readonly}
              onChange={(event) => {
                handleFieldChange("tax_acc_no", event.target.value);
              }}
            />
          </div>
          <div //attachment_url
            className="text-[14px] w-full h-full px-3 flex flex-col gap-2"
          >
            <div className="flex items-center gap-3">
              <label className="w-fit min-w-[150px] max-w-full">
                Attachments
              </label>
              {option !== "view" && (
                <button
                  className="border px-2 py-1 rounded-lg flex gap-1 items-center
                  hover:bg-Alice_Blue transition-all duration-150"
                  onClick={() => {
                    document.getElementById("FileInput").click();
                  }}
                >
                  <MdOutlineFileUpload className="text-[#20b25b] text-[18px] font-bold" />
                  Upload File
                </button>
              )}
            </div>

            <div className="flex flex-wrap gap-3">
              {Record?.attachment_url?.map((attached, index) => (
                <div
                  key={index}
                  className="cursor-pointer px-2 py-1 rounded-lg flex items-center gap-1 
                   hover:text-[#3f4fff] hover:bg-[#2a3cff] hover:bg-opacity-15
                   border border-gray-300 group transition-all duration-100"
                >
                  <span
                    onClick={() => {
                      store.navtotab(
                        baseurl + "/files/preview?key=" + attached
                      );
                    }}
                    className="text-[14px]"
                  >
                    {attached.replaceAll("customers_/", "")}
                  </span>

                  <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-150">
                    {/* <FaRegEye
                      className="text-blue-500 hover:text-blue-700 hover:bg-[#5ae271]"
                      onClick={() => {
                        store.navtotab(baseurl + "/files/preview?key=" + attached);
                      }}
                    /> */}
                    <IoIosCloseCircleOutline
                      className="text-red-500 hover:bg-[#FF0000]"
                      onClick={() => {
                        let attachment_url = Record.attachment_url || [];
                        attachment_url = attachment_url.filter(
                          (item, itemindex) => itemindex !== index
                        );
                        handleFieldChange("attachment_url", [
                          ...attachment_url,
                        ]);
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <input
              type="file"
              onChange={HandleAttachement}
              id="FileInput"
              className="hidden"
            />
          </div>
          <TabsView
            tabs={tabs}
            settabs={settabs}
            className="col-span-2 mt-1"
            tabsList={[
              {
                name: "Address",
                onClick: () => {
                  HandleMultiPropsChange({
                    address: { hidden: false },
                    // bank_name: { hidden: true },
                    // account_holder_name: { hidden: true },
                    // account_no: { hidden: true },
                    // ifsc_code: { hidden: true },
                    // branch: { hidden: true },
                    // bank_address: { hidden: true },
                    receivable_ledger_id: { hidden: true },
                    payable_ledger_id: { hidden: true },
                    salaes_ledger_id: { hidden: true },
                    secondary_emails: { hidden: true },
                  });
                },
              },
              {
                name: "Add Email's",
                onClick: () => {
                  HandleMultiPropsChange({
                    secondary_emails: { hidden: false },
                    address: { hidden: true },
                    receivable_ledger_id: { hidden: true },
                    payable_ledger_id: { hidden: true },
                    salaes_ledger_id: { hidden: true },
                  });
                },
              },
              {
                name: "Accounting",
                onClick: () => {
                  HandleMultiPropsChange({
                    address: { hidden: true },
                    // bank_name: { hidden: true },
                    // account_holder_name: { hidden: true },
                    // account_no: { hidden: true },
                    // ifsc_code: { hidden: true },
                    // branch: { hidden: true },
                    // bank_address: { hidden: true },
                    receivable_ledger_id: { hidden: false },
                    payable_ledger_id: { hidden: false },
                    salaes_ledger_id: { hidden: false },
                    secondary_emails: { hidden: true },
                  });
                },
              },
            ]}
          />

          {Record.address.map((address, addressId) => (
            <span
              className={
                "grid grid-cols-2 col-span-2 gap-3 " +
                (props?.address?.addressmandatory &&
                  props?.address?.addressmandatory[addressId] &&
                  " border-[#ff2828] border-2 ")
              }
            >
              <div
                className={
                  "col-span-2 flex items-center " +
                  (props.address.hidden ? " hidden " : " block ")
                }
              >
                <input
                  className="text-[18px]"
                  value={address.name}
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].name = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                />
                <FaEdit className="text-[18px] mr-1 opacity-25" />
                <hr className="flex-grow ml-3" />
                {option !== "view" && (
                  <button
                    className="hover:bg-Alice_Blue py-1 px-2 font-semibold text-[14px] border rounded-lg"
                    onClick={() => {
                      let newaddress = [...Record.address];
                      let addressprops = [...props.address.addressmandatory];
                      newaddress = newaddress.filter(
                        (item, index) => index != addressId
                      );
                      addressprops = addressprops.filter(
                        (item, index) => index != addressId
                      );
                      handleFieldChange("address", newaddress);
                      HandlePropsChange("address", {
                        ...props.address,
                        addressmandatory: addressprops,
                      });
                    }}
                  >
                    X
                  </button>
                )}
              </div>
              <div // address.Line_1
                className={
                  "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  Address Line 1
                  {props.address.addressmandatory && (
                    <span className="text-[#ff2828] text-[14px] h-fit">*</span>
                  )}
                </label>
                <input
                  className={
                    "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  id={"address"}
                  type="text"
                  value={address.line_1}
                  disabled={props.address.readonly}
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].line_1 = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                />
              </div>
              <div // address.Line_2
                className={
                  "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  Address Line 2
                  {/* {props.address.addressmandatory && (
                      <span className="text-[#ff2828] text-[14px] h-fit">
                        *
                      </span>
                    )} */}
                </label>
                <input
                  className={
                    "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  id={"address"}
                  type="text"
                  value={address.line_2}
                  disabled={props.address.readonly}
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].line_2 = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                />
              </div>
              <div // address.state
                className={
                  "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  State
                  {props.address.addressmandatory && (
                    <span className="text-[#ff2828] text-[14px] h-fit">*</span>
                  )}
                </label>
                <select
                  id={"address"}
                  onDragEnd={() => {
                    console.log("At end arraived");
                  }}
                  className={
                    " w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20   outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].state = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                  value={address.state}
                  disabled={props.address.readonly}
                  aria-placeholder="please select sam"
                >
                  {props.address.state_list.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div // address.country
                className={
                  "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  Country
                  {props.address.addressmandatory && (
                    <span className="text-[#ff2828] text-[14px] h-fit">*</span>
                  )}
                </label>
                <select
                  id={"address"}
                  onDragEnd={() => {
                    console.log("At end arraived");
                  }}
                  className={
                    " w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20   outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].country = event.target.value;
                    handleFieldChange("address", newaddress);
                    HandlePropsChange("address", {
                      ...address,
                      state_list: [
                        ...initProps.address.state_list,
                        ...states[event.target.value],
                      ],
                    });
                  }}
                  value={address.country}
                  disabled={props.address.readonly}
                  aria-placeholder="please select sam"
                >
                  {props.address.countries_list.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div // address.pincode
                className={
                  "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  Pincode
                  {props.address.addressmandatory && (
                    <span className="text-[#ff2828] text-[14px] h-fit">*</span>
                  )}
                </label>
                <input
                  className={
                    "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  id={"address"}
                  type="text"
                  value={address.pincode}
                  disabled={props.address.readonly}
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].pincode = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                />
              </div>
            </span>
          ))}
          {Record.secondary_emails.map(
            (secondary_emails, secondary_emailsId) => (
              <span
                className={
                  "grid grid-cols-2 col-span-2 gap-3 " +
                  (props?.secondary_emails?.secondary_emailsmandatory &&
                    props?.secondary_emails?.secondary_emailsmandatory[
                    secondary_emailsId
                    ] &&
                    " border-[#ff2828] border-2 ")
                }
              >
                <div
                  className={
                    "col-span-2 flex items-center " +
                    (props.secondary_emails.hidden ? " hidden " : " block ")
                  }
                >
                  <input
                    className="text-[18px]"
                    value={secondary_emails.name}
                    onChange={(event) => {
                      let newsecondary_emails = Record.secondary_emails;
                      newsecondary_emails[secondary_emailsId].name =
                        event.target.value;
                      handleFieldChange(
                        "secondary_emails",
                        newsecondary_emails
                      );
                    }}
                  />
                  <FaEdit className="text-[18px] mr-1 opacity-25" />
                  <hr className="flex-grow ml-3" />
                  {option !== "view" && (
                    <button
                      className="hover:bg-Alice_Blue py-1 px-2 font-semibold text-[14px] border rounded-lg"
                      onClick={() => {
                        let newsecondary_emails = [...Record.secondary_emails];
                        let secondary_emailsprops = [
                          ...props.secondary_emails.secondary_emailsmandatory,
                        ];
                        newsecondary_emails = newsecondary_emails.filter(
                          (item, index) => index != secondary_emailsId
                        );
                        secondary_emailsprops = secondary_emailsprops.filter(
                          (item, index) => index != secondary_emailsId
                        );
                        handleFieldChange(
                          "secondary_emails",
                          newsecondary_emails
                        );
                        HandlePropsChange("secondary_emails", {
                          ...props.secondary_emails,
                          secondary_emailsmandatory: secondary_emailsprops,
                        });
                      }}
                    >
                      X
                    </button>
                  )}
                </div>
                <div // secondary_emails.Line_1
                  className={
                    "text-[14px] w-full h-full px-3 flex-row items-center gap-3 col-span-2" +
                    (props.secondary_emails.hidden ? " hidden " : " flex ")
                  }
                >
                  <label className={"w-fit  min-w-[150px] max-w-full"}>
                    Email_id
                    {props.secondary_emails.secondary_emailsmandatory && (
                      <span className="text-[#ff2828] text-[14px] h-fit">
                        *
                      </span>
                    )}
                  </label>
                  <input
                    className={
                      "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                      (props.secondary_emails.secondary_emailsmandatory &&
                        props.secondary_emails.show
                        ? " rounded-2xl border-2 border-[#ff2828] "
                        : "")
                    }
                    id={"secondary_emails"}
                    type="text"
                    value={secondary_emails.email_Id}
                    disabled={props.secondary_emails.readonly}
                    onChange={(event) => {
                      let newsecondary_emails = Record.secondary_emails;
                      newsecondary_emails[secondary_emailsId].email_Id =
                        event.target.value;
                      handleFieldChange(
                        "secondary_emails",
                        newsecondary_emails
                      );
                    }}
                  />
                </div>
                <div // secondary_emails.Line_2
                  className={
                    "text-[14px] w-full h-full px-3 flex-row items-center gap-3 col-span-2" +
                    (props.secondary_emails.hidden ? " hidden " : " flex ")
                  }
                >
                  <label className={"w-fit  min-w-[150px] max-w-full"}>
                    Contact person
                    {/* {props.secondary_emails.secondary_emailsmandatory && (
                              <span className="text-[#ff2828] text-[14px] h-fit">
                                *
                              </span>
                            )} */}
                  </label>
                  <input
                    className={
                      "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                      (props.secondary_emails.secondary_emailsmandatory &&
                        props.secondary_emails.show
                        ? " rounded-2xl border-2 border-[#ff2828] "
                        : "")
                    }
                    id={"secondary_emails"}
                    type="text"
                    value={secondary_emails.person}
                    disabled={props.secondary_emails.readonly}
                    onChange={(event) => {
                      let newsecondary_emails = Record.secondary_emails;
                      newsecondary_emails[secondary_emailsId].person =
                        event.target.value;
                      handleFieldChange(
                        "secondary_emails",
                        newsecondary_emails
                      );
                    }}
                  />
                </div>
                <div // secondary_emails.Line_2
                  className={
                    "text-[14px] w-full h-full px-3 flex-row items-center gap-3 col-span-2" +
                    (props.secondary_emails.hidden ? " hidden " : " flex ")
                  }
                >
                  <label className={"w-fit  min-w-[150px] max-w-full"}>
                    Phone Number
                    {/* {props.secondary_emails.secondary_emailsmandatory && (
                              <span className="text-[#ff2828] text-[14px] h-fit">
                                *
                              </span>
                            )} */}
                  </label>
                  <input
                    className={
                      "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                      (props.secondary_emails.secondary_emailsmandatory &&
                        props.secondary_emails.show
                        ? " rounded-2xl border-2 border-[#ff2828] "
                        : "")
                    }
                    id={"secondary_emails"}
                    type="text"
                    value={secondary_emails.phoneno}
                    disabled={props.secondary_emails.readonly}
                    onChange={(event) => {
                      let newsecondary_emails = Record.secondary_emails;
                      newsecondary_emails[secondary_emailsId].phoneno =
                        event.target.value;
                      handleFieldChange(
                        "secondary_emails",
                        newsecondary_emails
                      );
                    }}
                  />
                </div>
              </span>
            )
          )}

          {option !== "view" && (
            <div
              className={
                "col-span-2 " +
                (props.secondary_emails.hidden ? " hidden " : " block ")
              }
            >
              <button
                className=" hover:bg-Ocean_Blue hover:text-secondary bg-Alice_Blue border p-2 rounded-lg"
                onClick={() => {
                  let newsecondary_emails = [...Record.secondary_emails];
                  let newsecondary_emailsProps = [
                    ...props.secondary_emails.secondary_emailsmandatory,
                  ];
                  if (
                    newsecondary_emails.filter(
                      (item) => item.name === "other secondary_emails"
                    ).length > 0
                  ) {
                    WarningAlert(
                      'secondary_emails with the same name "Other secondary_emails" is already exist. Please Change the secondary_emails header name'
                    );
                  } else {
                    newsecondary_emails.push({
                      name: "Email Id " + (Record.secondary_emails.length + 1),
                      email_Id: "",
                    });
                    newsecondary_emailsProps.push(false);
                    handleFieldChange("secondary_emails", newsecondary_emails);
                    HandlePropsChange("secondary_emails", {
                      ...props.secondary_emails,
                      secondary_emailsmandatory: [...newsecondary_emailsProps],
                    });
                  }
                }}
              >
                Add secondary_emails
              </button>
            </div>
          )}

          {option !== "view" && (
            <div
              className={
                "col-span-2 " + (props.address.hidden ? " hidden " : " block ")
              }
            >
              <button
                className=" hover:bg-Ocean_Blue hover:text-secondary bg-Alice_Blue border p-2 rounded-lg"
                onClick={() => {
                  let newaddress = [...Record.address];
                  let newaddressProps = [...props.address.addressmandatory];
                  if (
                    newaddress.filter((item) => item.name === "other Address")
                      .length > 0
                  ) {
                    WarningAlert(
                      'Address with the same name "Other Address" is already exist. Please Change the Address header name'
                    );
                  } else {
                    if (newaddress.length == 1) {
                      newaddress.push({
                        name: "Delivery Address",
                        line_1: "",
                        line_2: "",
                        state: "",
                        country: "",
                        pincode: "",
                      });
                    } else if (newaddress.length == 0) {
                      newaddress.push({
                        name: "Permanent Address",
                        line_1: "",
                        line_2: "",
                        state: "",
                        country: "",
                        pincode: "",
                      });
                    } else {
                      newaddress.push({
                        name: "other Address",
                        line_1: "",
                        line_2: "",
                        state: "",
                        country: "",
                        pincode: "",
                      });
                    }
                    newaddressProps.push(false);
                    handleFieldChange("address", newaddress);
                    HandlePropsChange("address", {
                      ...props.address,
                      addressmandatory: [...newaddressProps],
                    });
                  }
                }}
              >
                Add Address
              </button>
            </div>
          )}

          <div // receivable_ledger_id
            className={
              "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 col-span-2 " +
              (props.receivable_ledger_id.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Account Receivable
              {props.receivable_ledger_id.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <select
              id={"receivable_ledger_id"}
              onDragEnd={() => {
                console.log("At end arraived");
              }}
              className={
                " w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20   outline-none " +
                (props.receivable_ledger_id.mandatory &&
                  props.receivable_ledger_id.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              onChange={(event) => {
                handleFieldChange("receivable_ledger_id", event.target.value);
              }}
              value={Record.receivable_ledger_id}
              disabled={props.receivable_ledger_id.readonly}
              aria-placeholder="please select sam"
            >
              {props.receivable_ledger_id.receivable_ledger_id_list.map(
                (item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                )
              )}
            </select>
          </div>
          <div // payable_ledger_id
            className={
              "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 col-span-2 " +
              (props.payable_ledger_id.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Account Payable
              {props.payable_ledger_id.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <select
              id={"payable_ledger_id"}
              onDragEnd={() => {
                console.log("At end arraived");
              }}
              className={
                " w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20   outline-none " +
                (props.payable_ledger_id.mandatory &&
                  props.payable_ledger_id.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              onChange={(event) => {
                handleFieldChange("payable_ledger_id", event.target.value);
              }}
              value={Record.payable_ledger_id}
              disabled={props.payable_ledger_id.readonly}
              aria-placeholder="please select sam"
            >
              {props.payable_ledger_id.payable_ledger_id_list.map(
                (item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                )
              )}
            </select>
          </div>
          <div // salaes_ledger_id
            className={
              "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 col-span-2 " +
              (props.salaes_ledger_id.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Sales Account
              {props.salaes_ledger_id.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <select
              id={"salaes_ledger_id"}
              onDragEnd={() => {
                console.log("At end arraived");
              }}
              className={
                " w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20   outline-none " +
                (props.salaes_ledger_id.mandatory && props.salaes_ledger_id.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              onChange={(event) => {
                handleFieldChange("salaes_ledger_id", event.target.value);
              }}
              value={Record.salaes_ledger_id}
              disabled={props.salaes_ledger_id.readonly}
              aria-placeholder="please select sam"
            >
              {props.salaes_ledger_id.salaes_ledger_id_list.map(
                (item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                )
              )}
            </select>
          </div>

          {option === "view" && (
            <ChildTabsView
              className="col-span-2 mt-1"
              tabsList={Record.child || {}}
              store={store}
              LoadInitData={LoadInitData}
              companyId={companyId}
            />
          )}
        </div>
      </div>
    </div>
  );
};

// function ChildTabsView({
//   tabsList = {},
//   className = "",
//   store,
//   LoadInitData,
//   companyId,
// }) {
//   const [tabs, settabs] = useState("Projects");
//   const props = getlocal("properties");

//   return (
//     <div className={className}>
//       <ul
//         className={
//           className +
//           " flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
//         }
//       >
//         <li className="me-2">
//           {tabsList?.Projects?.list?.length > 0 && (
//             <button
//               className={
//                 " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
//                 ("Projects" === tabs
//                   ? " bg-Ocean_Blue text-secondary "
//                   : " bg-Alice_Blue ")
//               }
//               onClick={() => {
//                 settabs("Projects");
//               }}
//             >
//               {"Projects" +
//                 (("Projects" === tabs &&
//                   " - " + tabsList[tabs]?.list?.length) ||
//                   "")}
//             </button>
//           )}
//           {props.contacts.view && tabsList?.Contacts?.list?.length > 0 && (
//             <button
//               className={
//                 " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
//                 ("Contacts" === tabs
//                   ? " bg-Ocean_Blue text-secondary "
//                   : " bg-Alice_Blue ")
//               }
//               onClick={() => {
//                 settabs("Contacts");
//               }}
//             >
//               {"Contacts" +
//                 (("Contacts" === tabs &&
//                   " - " + tabsList[tabs]?.list?.length) ||
//                   "")}
//             </button>
//           )}
//           {props.invoices.view && tabsList?.invoices?.list?.length > 0 && (
//             <button
//               className={
//                 " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
//                 ("invoices" === tabs
//                   ? " bg-Ocean_Blue text-secondary "
//                   : " bg-Alice_Blue ")
//               }
//               onClick={() => {
//                 settabs("invoices");
//               }}
//             >
//               {"Invoices" +
//                 (("invoices" === tabs &&
//                   " - " + tabsList[tabs]?.list?.length) ||
//                   "")}
//             </button>
//           )}
//           {props.Expenses.view && tabsList?.expences?.list?.length > 0 && (
//             <button
//               className={
//                 " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
//                 ("expences" === tabs
//                   ? " bg-Ocean_Blue text-secondary "
//                   : " bg-Alice_Blue ")
//               }
//               onClick={() => {
//                 settabs("expences");
//               }}
//             >
//               {"Expences" +
//                 (("expences" === tabs &&
//                   " - " + tabsList[tabs]?.list?.length) ||
//                   "")}
//             </button>
//           )}
//           {props.receipts.view && tabsList?.receipts?.list?.length > 0 && (
//             <button
//               className={
//                 " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
//                 ("receipts" === tabs
//                   ? " bg-Ocean_Blue text-secondary "
//                   : " bg-Alice_Blue ")
//               }
//               onClick={() => {
//                 settabs("receipts");
//               }}
//             >
//               {"Receipts" +
//                 (("receipts" === tabs &&
//                   " - " + tabsList[tabs]?.list?.length) ||
//                   "")}
//             </button>
//           )}
//           {props.journals.view && tabsList?.journals?.list?.length > 0 && (
//             <button
//               className={
//                 " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
//                 ("journals" === tabs
//                   ? " bg-Ocean_Blue text-secondary "
//                   : " bg-Alice_Blue ")
//               }
//               onClick={() => {
//                 settabs("journals");
//               }}
//             >
//               {"Journals" +
//                 (("journals" === tabs &&
//                   " - " + tabsList[tabs]?.list?.length) ||
//                   "")}
//             </button>
//           )}
//         </li>
//       </ul>

//       <ListView
//         Tablehead={"font-bold text-[18px]"}
//         Tablerecord="pr-[10px] text-[14px] cursor-pointer "
//         onclick={(index) => {
//           console.log("indexreport", index, tabs);

//           if (tabs === "Projects") {
//             if (index.type == "Non-Litigation") {
//               store.navTo("/" + URLPRIFIX + "/projects/view/" + index?.id);
//             } else if (index.type == "Litigation") {
//               store.navTo(
//                 "/" + URLPRIFIX + "/litigation/projects/view/" + index?.id
//               );
//             } else if (index.type == "TradeMark") {
//               store.navTo(
//                 "/" + URLPRIFIX + "/trademark/projects/view/" + index?.id
//               );
//             }
//           }
//           if (tabs === "Contacts") {
//             store.navTo("/" + URLPRIFIX + "/contacts/view/" + index?.id);
//           }
//           if (tabs === "invoices") {
//             store.navTo(
//               "/" +
//                 URLPRIFIX +
//                 "/" +
//                 companyId +
//                 "/accounts/invoice/view/" +
//                 index?.id
//             );
//           }
//           if (tabs === "expences") {
//             store.navTo(
//               "/" +
//                 URLPRIFIX +
//                 "/" +
//                 companyId +
//                 "/accounts/expense/view/" +
//                 index?.id
//             );
//           }
//           if (tabs === "receipts") {
//             store.navTo(
//               "/" +
//                 URLPRIFIX +
//                 "/" +
//                 companyId +
//                 "/accounts/receipt/view/" +
//                 index?.id
//             );
//           }
//           if (tabs === "journals") {
//             store.navTo(
//               "/" +
//                 URLPRIFIX +
//                 "/" +
//                 companyId +
//                 "/accounts/journal/view/" +
//                 index?.id
//             );
//           }
//         }}
//         ondelete={
//           tabs == "Projects" && props.nonlitigation_projects.delete
//             ? (item) => {
//                 DeleteRecord("/project/deleteproject/" + item.id, {
//                   modifiedBy: store.getuser().id,
//                 }).then((res) => {
//                   if (res.success) {
//                     SuccessAlert("Deleted Successfully");
//                     LoadInitData();
//                   } else {
//                     store.stopLoading();
//                     ErrorAlert(
//                       res?.errormessage?.response.data ||
//                         " Unknown Error Found Please contact the Admin"
//                     );
//                   }
//                 });
//               }
//             : tabs == "Contacts" && props.contacts.delete
//             ? (item) => {
//                 DeleteRecord("/contact/deletecontacts/" + item.id, {
//                   modifiedBy: store.getuser().id,
//                 }).then((res) => {
//                   if (res.success) {
//                     SuccessAlert("Deleted Successfully");
//                     LoadInitData();
//                   } else {
//                     store.stopLoading();
//                     ErrorAlert(
//                       res?.errormessage?.response.data ||
//                         " Unknown Error Found Please contact the Admin"
//                     );
//                   }
//                 });
//               }
//             : undefined
//         }
//         height={"fit"}
//         header={tabsList[tabs]?.header || []}
//         records={tabsList[tabs]?.list || []}
//       />
//     </div>
//   );
// }
function ChildTabsView({ tabsList = {}, className = "", store, LoadInitData, companyId }) {
  const { option, id } = useParams();

  const [tabs, settabs] = useState("Projects");
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [exportFormat, setExportFormat] = useState("pdf");

  const props = getlocal("properties");

  const [selectedRecords, setSelectedRecords] = useState([]);
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ field: "", direction: "asc" });

  const handleOnSelect = (item, isChecked) => {
    setSelectedRecords((prev) =>
      isChecked ? [...prev, item] : prev.filter((i) => i.id !== item.id)
    );
  };

  const isSelected = (item) => selectedRecords.some((i) => i.id === item.id);

  const handleSelectAll = () => {
    const all = tabsList[tabs]?.list || [];
    if (selectedRecords.length === all.length) {
      setSelectedRecords([]);
    } else {
      setSelectedRecords(all);
    }
  };

  const handleClickRow = (item) => {
    switch (tabs) {
      case "Projects":
        if (item.type === "Non-Litigation") {
          store.navTo(`/${URLPRIFIX}/projects/view/${item.id}`);
        } else if (item.type === "Litigation") {
          store.navTo(`/${URLPRIFIX}/litigation/projects/view/${item.id}`);
        } else if (item.type === "TradeMark") {
          store.navTo(`/${URLPRIFIX}/trademark/projects/view/${item.id}`);
        }
        break;
      case "Contacts":
        store.navTo(`/${URLPRIFIX}/contacts/view/${item.id}`);
        break;
      case "invoices":
        store.navTo(`/${URLPRIFIX}/${companyId}/accounts/invoice/view/${item.id}`);
        break;
      case "expences":
        store.navTo(`/${URLPRIFIX}/${companyId}/accounts/expense/view/${item.id}`);
        break;
      case "receipts":
        store.navTo(`/${URLPRIFIX}/${companyId}/accounts/receipt/view/${item.id}`);
        break;
      case "journals":
        store.navTo(`/${URLPRIFIX}/${companyId}/accounts/journal/view/${item.id}`);
        break;
      default:
        console.warn(`Navigation for tab "${tabs}" not defined.`);
        break;
    }
  };

  const handleSort = (label) => {
    setSortConfig((prev) => ({
      field: label,
      direction: prev.field === label && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const onFilterChange = (label, value) => {
    setFilters((prev) => ({ ...prev, [label]: value }));
  };

  const handleBulkDelete = () => {
    let apiPath = "";
    let deletePermission = false;

    if (tabs === "Projects") {
      apiPath = "/project/deleteproject/";
      deletePermission = props.nonlitigation_projects?.delete;
    } else if (tabs === "Contacts") {
      apiPath = "/contact/deletecontacts/";
      deletePermission = props.contacts?.delete;
    }

    if (!deletePermission || !apiPath) {
      ErrorAlert("You don't have permission to perform bulk delete for this tab, or it's not supported.");
      return;
    }

    if (window.confirm("Are you sure you want to delete the selected records?")) {
      store.startLoading();
      Promise.all(
        selectedRecords.map((item) =>
          DeleteRecord(`${apiPath}${item.id}`, { modifiedBy: store.getuser().id })
        )
      )
        .then(() => {
          SuccessAlert("Selected records deleted successfully!");
          LoadInitData();
          setSelectedRecords([]);
        })
        .catch((error) => {
          console.error("Bulk delete error:", error);
          ErrorAlert("Bulk delete failed. Please try again.");
        })
        .finally(() => {
          store.stopLoading();
        });
    }
  };

  const filteredRecords = (tabsList[tabs]?.list || [])
    .filter((item) =>
      Object.entries(filters).every(([key, value]) =>
        item[key]?.toString()?.toLowerCase().includes(value.toLowerCase())
      )
    )
    .sort((a, b) => { 
      if (sortConfig.field) {
        const aValue = a[sortConfig.field];
        const bValue = b[sortConfig.field];
        if (aValue === null || aValue === undefined) return sortConfig.direction === "asc" ? 1 : -1;
        if (bValue === null || bValue === undefined) return sortConfig.direction === "asc" ? -1 : 1;
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          const comparison = aValue.localeCompare(bValue);
          return sortConfig.direction === "asc" ? comparison : -comparison;
        } else {
          if (aValue < bValue) {
            return sortConfig.direction === "asc" ? -1 : 1;
          }
          if (aValue > bValue) {
            return sortConfig.direction === "asc" ? 1 : -1;
          }
          return 0;
        }
      }
      return 0; 
    });

  const handleExport = (format) => {
    const selectedProject = selectedRecords.some((r) =>
      (tabsList?.Projects?.list || []).some((p) => p.id === r.id)
    );
    // Removed selectedForm check as there's no form tab

    setExportFormat(format);

    // Simplification: If only projects are exportable from selected records, no need for mixed options modal
    // This assumes no other mixed types, if there are, you'll need to adapt.
    handleConfirmedExport({
      projects: selectedProject,
      forms: false, // Explicitly false as forms are removed
    });
  };

  const handleConfirmedExport = async (options) => {
    setShowExportOptions(false);

    const contactId = selectedRecords[0]?.contactId ?? id;
    if (!contactId) {
      alert("Missing contact ID for export. Please select records associated with a contact.");
      return;
    }

    // const allForms = tabsList?.formDetails?.list || []; // Removed
    const allProjects = tabsList?.Projects?.list || [];

    // const selectedFormIds = options.forms // Removed
    //   ? selectedRecords
    //       .filter((r) => allForms.some((f) => f.id === r.id))
    //       .map((r) => `formIds=${r.id}`)
    //   : [];

    const selectedProjectIds = options.projects
      ? selectedRecords
        .filter((r) => allProjects.some((p) => p.id === r.id))
        .map((r) => `projectIds=${r.id}`)
      : [];

    let query = `format=${exportFormat}`;
    if (selectedProjectIds.length) query += `&${selectedProjectIds.join("&")}`;
    // if (selectedFormIds.length) query += `&${selectedFormIds.join("&")}`; // Removed

    if (!selectedProjectIds.length) { // Simplified check for valid records
      alert("No valid records selected for export.");
      return;
    }

    store.startLoading();

    try {
      const res = await GetRecords(`/contact/contacts/export/${contactId}?${query}`);
      const url = res?.record?.url;
      if (url) {
        window.open(url, "_blank");
      } else {
        alert("Export failed: No URL returned from the server.");
      }
    } catch (err) {
      console.error(`${exportFormat.toUpperCase()} export error:`, err);
      ErrorAlert(`${exportFormat.toUpperCase()} export failed. Please try again.`);
    } finally {
      store.stopLoading();
    }
  };

  useEffect(() => {
    let currentTabHasPermission = false;
    let currentTabHasData = (tabsList[tabs]?.list?.length || 0) > 0;

    if (tabs === "Projects") currentTabHasPermission = props.nonlitigation_projects?.view;
    else if (tabs === "Contacts") currentTabHasPermission = props.contacts?.view;
    // Removed formDetails check
    else if (tabs === "expences") currentTabHasPermission = props.Expenses?.view;
    else if (tabs === "invoices") currentTabHasPermission = props.invoices?.view;
    else if (tabs === "receipts") currentTabHasPermission = props.receipts?.view;
    else if (tabs === "journals") currentTabHasPermission = props.journals?.view;

    if (!currentTabHasData || !currentTabHasPermission) {
      if (props.nonlitigation_projects?.view && tabsList?.Projects?.list?.length) {
        settabs("Projects");
      } else if (props.contacts?.view && tabsList?.Contacts?.list?.length) {
        settabs("Contacts");
      }
      // Removed formDetails fallback
      else if (props.invoices?.view && tabsList?.invoices?.list?.length) {
        settabs("invoices");
      } else if (props.Expenses?.view && tabsList?.expences?.list?.length) {
        settabs("expences");
      } else if (props.receipts?.view && tabsList?.receipts?.list?.length) {
        settabs("receipts");
      } else if (props.journals?.view && tabsList?.journals?.list?.length) {
        settabs("journals");
      }
    }
  }, [tabsList, props, tabs]);

  return (
    <div className={className}>
      <ul className="flex flex-wrap text-sm font-medium border-b text-gray-500">
        {props.nonlitigation_projects.view && tabsList?.Projects?.list?.length > 0 && (
          <button
            onClick={() => settabs("Projects")}
            className={`p-2 rounded-t-lg ${tabs === "Projects" ? "bg-Ocean_Blue text-secondary" : "bg-Alice_Blue"
              }`}
          >
            Projects - {tabsList?.Projects?.list?.length}
          </button>
        )}

        {props.contacts.view && tabsList?.Contacts?.list?.length > 0 && (
          <button
            onClick={() => settabs("Contacts")}
            className={`p-2 rounded-t-lg ${tabs === "Contacts" ? "bg-Ocean_Blue text-secondary" : "bg-Alice_Blue"
              }`}
          >
            Contacts - {tabsList?.Contacts?.list?.length}
          </button>
        )}

        {/* Removed Forms Tab Button */}

        {props.invoices.view && tabsList?.invoices?.list?.length > 0 && (
          <button
            className={`p-2 rounded-t-lg ${tabs === "invoices" ? " bg-Ocean_Blue text-secondary " : " bg-Alice_Blue "
              }`}
            onClick={() => {
              settabs("invoices");
            }}
          >
            Invoices - {tabsList?.invoices?.list?.length}
          </button>
        )}

        {props.Expenses.view && tabsList?.expences?.list?.length > 0 && (
          <button
            className={`p-2 rounded-t-lg ${tabs === "expences" ? " bg-Ocean_Blue text-secondary " : " bg-Alice_Blue "
              }`}
            onClick={() => {
              settabs("expences");
            }}
          >
            Expenses - {tabsList?.expences?.list?.length}
          </button>
        )}

        {props.receipts.view && tabsList?.receipts?.list?.length > 0 && (
          <button
            className={`p-2 rounded-t-lg ${tabs === "receipts" ? " bg-Ocean_Blue text-secondary " : " bg-Alice_Blue "
              }`}
            onClick={() => {
              settabs("receipts");
            }}
          >
            Receipts - {tabsList?.receipts?.list?.length}
          </button>
        )}

        {props.journals.view && tabsList?.journals?.list?.length > 0 && (
          <button
            className={`p-2 rounded-t-lg ${tabs === "journals" ? " bg-Ocean_Blue text-secondary " : " bg-Alice_Blue "
              }`}
            onClick={() => {
              settabs("journals");
            }}
          >
            Journals - {tabsList?.journals?.list?.length}
          </button>
        )}
      </ul>

      {selectedRecords.length > 0 && (
        <BulkActionsBar
          selectedRecords={selectedRecords}
          store={store}
          onBulkDelete={handleBulkDelete}
          onExportPDF={() => handleExport("pdf")}
          onExportExcel={() => handleExport("excel")}
        />
      )}

      {/* ExportOptionsModal is kept, but its internal logic might need review if mixed types are no longer expected */}
      <ExportOptionsModal
        isOpen={showExportOptions}
        onClose={() => setShowExportOptions(false)}
        onExport={handleConfirmedExport}
      />

      <ListViewUp
        header={tabsList[tabs]?.header || []}
        filteredRecords={filteredRecords}
        Tablehead={"font-bold text-[16px]"}
        Tablerecord="text-[14px] px-2 py-1"
        sortConfig={sortConfig}
        handleSort={handleSort}
        filters={filters}
        onFilterChange={onFilterChange}
        store={store}
        handleOnSelect={handleOnSelect}
        isSelected={isSelected}
        handleClickRow={handleClickRow}
        handleDelete={(item) => {
          let api = "";
          let deletePermission = false;

          if (tabs === "Projects" && props.nonlitigation_projects?.delete) {
            api = "/project/deleteproject/";
            deletePermission = true;
          } else if (tabs === "Contacts" && props.contacts?.delete) {
            api = "/contact/deletecontacts/";
            deletePermission = true;
          }

          if (!deletePermission || !api) {
            ErrorAlert("You don't have permission to delete this record or delete is not supported for this tab.");
            return;
          }

          if (window.confirm("Are you sure you want to delete this record?")) {
            store.startLoading();
            DeleteRecord(api + item.id, { modifiedBy: store.getuser().id })
              .then((res) => {
                if (res.success) {
                  SuccessAlert("Deleted Successfully!");
                  LoadInitData();
                } else {
                  ErrorAlert(
                    res?.errormessage?.response?.data || "Unknown Error, please contact Admin"
                  );
                }
              })
              .catch((error) => {
                console.error("Delete error:", error);
                ErrorAlert("Deletion failed. Please try again.");
              })
              .finally(() => {
                store.stopLoading();
              });
          }
        }}
        handleSelectAll={handleSelectAll}
        isAllSelected={selectedRecords.length === (tabsList[tabs]?.list?.length || 0)}
        tablename={tabs}
      />
    </div>
  );
}

export default CustomerForm;
